// PROD-3310 billing bridge.
// Mirrors: dev-scrips-pm-react src/components/ui/input.tsx (base-ui Input on PM's FIELD_LOOK, 40 tall; every native
// input prop passes through).
// Wraps:   Signal DS `TextField` (the one field look, 40 tall, restyled app-wide by `src/styles/showcase-bridge.css`).
// Overrides: PM's `className` lands on the DS input element (`inputClassName`), where PM put it, so a call site's
// `pl-10` still clears a leading glyph. PM passes no `size` (the native attribute); the DS `size` axis stays default.
import { forwardRef, type InputHTMLAttributes } from 'react';
import { TextField } from '@scripsteam/scrips-signal-ds';

export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'dir'> & { dir?: 'ltr' | 'rtl' };

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ className, ...props }, ref) {
  return <TextField ref={ref} data-slot="input" inputClassName={className} {...props} />;
});
